import { Component, OnInit } from '@angular/core';

import { Credential } from '../models/Credential';
import { PasswordService } from '../services/PasswordService';

@Component({
    selector: 'user-forgot-password',
    template: require('./HolForgotPasswordComponent.html'),
    styles: [require('./HolForgotPasswordComponent.sass')],
})

export class HolForgotPasswordComponent implements OnInit {
    credential: Credential;
    message: string;
    messageType: string;
    formSubmitted: boolean = false;

    constructor(
        private passwordService: PasswordService
    ) {}

    ngOnInit() {
        this.credential = new Credential('hol-parent', '', '');
    }
    
    onSubmit() {
        // Call API service to send a reset password email
        // when user submit the email address
        this.formSubmitted = true;
        this.sendResetPasswordEmail(this.credential);
    }

    /**
     * Call API service to send the credential and request for a reset password email.
     * @param {Credential} - user credential
     * @complete - Update message & messageType for display, reset credential.
     * @error - Set message & messageType as error. Reset form submit.
     */
    private sendResetPasswordEmail(credential: Credential) {
        this.passwordService.sendResetPasswordEmail(credential.role, credential.email)
            .subscribe(
                complete => {
                    this.messageType = "success",
                    this.message = "A reset password email had been sent.";
                    this.formSubmitted = false;
                },
                error => {
                    this.messageType = "alert";
                    this.message = "Cannot send reset password email.";
                    this.formSubmitted = false;
                }
            );
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/hol-forgot-password/HolForgotPasswordComponent.ts